import React, { FC } from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import {
  Text,
  Stack,
  Card,
  Button,
  PresentationItem,
  HorizontalLine,
} from '@components'

import { UserPresentationsScreenOtherPresentationsSection_user$key } from './__generated__/UserPresentationsScreenOtherPresentationsSection_user.graphql'

export const UserPresentationsScreenOtherPresentationsSection: FC<{
  user: UserPresentationsScreenOtherPresentationsSection_user$key
}> = ({ user }) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment UserPresentationsScreenOtherPresentationsSection_user on User
      @refetchable(
        queryName: "UserPresentationsScreenOtherPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        otherPresentations: presentations(
          first: $count
          after: $cursor
          timeSelection: OTHER
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "UserPresentationsScreenOtherPresentationsSection_user_otherPresentations"
          ) {
          edges {
            node {
              ...PresentationItem_presentation
            }

            cursor
          }
        }
      }
    `,
    user
  )

  if (data.otherPresentations.edges.length === 0) {
    return null
  }

  return (
    <>
      <Stack direction='horizontal' gap={4} alignItems='center'>
        <Text size={4} variant='cardHeading'>
          Other Presentations
        </Text>

        <HorizontalLine variant='cardHeading' />
      </Stack>

      {data.otherPresentations.edges.map((edge) => {
        return (
          <Card variant='main' gap={4} key={edge.cursor}>
            <PresentationItem presentation={edge.node} />
          </Card>
        )
      })}

      {hasNext && (
        <Button
          variant='secondary'
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Text variant='buttonSecondary'>
            {isLoadingNext ? 'Loading...' : '+'}
          </Text>
        </Button>
      )}
    </>
  )
}
